export default "__VITE_ASSET__v2QeZm_w__"